import React, { useEffect, useState } from "react";
import { Box, Typography, Card } from "@mui/material";
import { useParams } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PhoneIcon from "@mui/icons-material/Phone";
import TelegramIcon from "@mui/icons-material/Telegram";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import WorkIcon from "@mui/icons-material/Work";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { API_URL } from "../../util/url";
import fetchWithAuth from "../../util/fetchWithAuth";

export default function OperatorProfileView({
  operatorId,
  operatorData,
  disableFetch = false,
}) {
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (operatorData && typeof operatorData === "object") {
      setForm(operatorData);
      return;
    }
    if (disableFetch || !operatorId) return;
    const fetchOperator = async () => {
      try {
        const res = await fetchWithAuth(
          `${API_URL}/user/operators/${operatorId}/`
        );
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const data = await res.json();
        setForm(data || null);
      } catch (err) {
        console.error("Помилка при завантаженні оператора", err);
      }
    };
    fetchOperator();
  }, [operatorId, operatorData]);

  if (!form) return <Typography>Завантаження...</Typography>;

  const InfoRow = ({ icon, label, value }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {icon}
      <Typography sx={{ color: "#ccc", fontSize: 13 }}>{label}</Typography>
      <Typography sx={{ color: "white", fontWeight: 500 }}>
        {value || "-"}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 3, color: "white" }}
    >
      {/* Header */}
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderRadius: 2,
          backgroundColor: "#0E0E11",
        }}
      >
        <PersonIcon sx={{ fontSize: 56, color: "white", mr: 2 }} />
        <Box>
          <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
            {form.last_name} {form.first_name}
          </Typography>
          <Typography sx={{ color: "gray", fontSize: 14 }}>
            {form.role || "Оператор"}
          </Typography>
        </Box>
      </Card>

      {/* Info grid */}
      <Card
        sx={{
          backgroundColor: "#141417",
          borderRadius: 2,
          p: 3,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 3,
        }}
      >
        <InfoRow
          icon={<MonetizationOnIcon sx={{ color: "white" }} />}
          label="Зарплатня:"
          value={`${form.salary_amount || 0}₴`}
        />
        <InfoRow
          icon={<LockOpenIcon sx={{ color: "white" }} />}
          label="Дата звільнення:"
          value={form.date_of_end}
        />
        <InfoRow
          icon={<WorkIcon sx={{ color: "white" }} />}
          label="Початок роботи:"
          value={form.date_of_start}
        />
        <InfoRow
          icon={<CalendarTodayIcon sx={{ color: "white" }} />}
          label="Дата народження:"
          value={form.birthday_date}
        />
        <InfoRow
          icon={<PersonIcon sx={{ color: "white" }} />}
          label="Логін:"
          value={form.username}
        />
        <InfoRow
          icon={<EmailIcon sx={{ color: "white" }} />}
          label="Пошта:"
          value={form.email}
        />
        <InfoRow
          icon={<PhoneIcon sx={{ color: "white" }} />}
          label="Телефон:"
          value={form.phone_number}
        />
        <InfoRow
          icon={<TelegramIcon sx={{ color: "white" }} />}
          label="Телеграм:"
          value={form.telegram}
        />
      </Card>
    </Box>
  );
}
